module.exports = __webpack_public_path__ + "img/c3.d56ffe08.svg";